export default __webpack_public_path__ + "static/media/login_illustration.5e1dda16.png";